export const SERVER_URL =
  'https://iailfwyra0.execute-api.us-east-2.amazonaws.com';
